import { gql } from '@apollo/client'
import { auctionPlayer } from './ipl-auction.query'

export const GET_LIVE_AUCTION_SUMMARY_QUERY = gql`
  query GetLiveAuctionSummary($input: oGetLiveAuctionSummaryInput!) {
    getLiveAuctionSummary(input: $input) {
      oData {
        eBidOperation
        aRecentPickPlayers {
          _id
          oPlayer {
            oImg {
              sUrl
              sText
            }
            sFullName
          }
          sPlayingRole
          eAuctionStatus
          nBasePrice
          nSoldPrice
          oTeam {
            oImg {
              sUrl
              sText
            }
            sAbbr
            oJersey {
              sUrl
              sText
            }
          }
          oPrimaryTeam {
            sTitle
            oImg {
              sUrl
              sText
            }
            oJersey {
              sUrl
              sText
            }
          }
          oCountry {
            sTitle
            oImg {
              sUrl
              sText
            }
          }
        }
        oCurrentPlayer {
          oPlayer {
            sFullName
            oImg {
              sUrl
              sText
            }
          }
          nBasePrice
          sPlayingRole
          oPrimaryTeam {
            sAbbr
            oImg {
              sUrl
              sText
            }
            oJersey {
              sUrl
              sText
            }
          }
          oCountry {
            sTitle
            oImg {
              sUrl
              sText
            }
          }
          aBid {
            nBidPrice
            oTeam {
              sTitle
              oImg {
                sUrl
                sText
              }
            }
            bSold
            bRTM
          }
          nSoldPrice
          eAuctionStatus
        }
      }
    }
  }
`

export const GET_LIVE_AUCTION_OVERVIEW = gql`
query GetAuctionSeriesOverview($input: oGetAuctionSeriesInput!) {
  getAuctionSeriesOverview(input: $input) {
    aTopAllRounderData {
      ${auctionPlayer}
    }
    aTopBatterData {
      ${auctionPlayer}
    }
    aTopBowlerData {
      ${auctionPlayer}
    }
    nRTMUsed
    nTotalMoneySpent
    nTotalOverseasPlayer
    nTotalRegisteredPlayer
    nTotalSoldPlayer
    nTotalUnSoldPlayer
  }
}
`
